import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../../Styles/ann-tokens.css";
import "../../Styles/marketing-base.css";
import "../../Styles/subpage.css";
import "../../Styles/anneffect.css";
import useReveal from "../marketing/useReveal";
import { testimonials, ctestimonials } from "./testimonialData";

/* Extract plain text from a JSX node or string */
function toText(node) {
  if (!node) return "";
  if (typeof node === "string") return node;
  if (Array.isArray(node)) return node.map(toText).join(" ");
  if (node.props?.children) return toText(node.props.children);
  return "";
}

const API_BASE = "/ann/ann-ai-cms/public/";

export default function AnnEffect() {
  const ref = useReveal();
  const [clientList, setClientList] = useState(testimonials);
  const [candidateList, setCandidateList] = useState(ctestimonials);

  useEffect(() => {
    fetch(`${API_BASE}api/content/client-testimonials`)
      .then((r) => r.json())
      .then((d) => { if (d?.content?.length) setClientList(d.content); })
      .catch(() => {});

    fetch(`${API_BASE}api/content/candidate-testimonials`)
      .then((r) => r.json())
      .then((d) => { if (d?.content?.length) setCandidateList(d.content); })
      .catch(() => {});
  }, []);

  /* Double arrays for seamless infinite marquee */
  const clients   = [...clientList,    ...clientList];
  const candidates = [...candidateList, ...candidateList];

  return (
    <div className="page ann-subpage" ref={ref}>

      {/* ── CLIENT TESTIMONIALS ──────────────────────────────── */}
      <section className="ae-section">
        <div className="sub-head">
          <span className="eye">Hiring teams</span>
          <h2 className="sub-h2">What hiring managers say</h2>
        </div>
        <div className="ae-marquee">
          <div className="ae-track">
            {clients.map((t, i) => {
              const text   = t.content_text  ?? (typeof t.text === "string" ? t.text : "");
              const name   = t.content_title ?? t.name  ?? "";
              const role   = t.content_subtitle ?? t.title ?? "";
              const avatar = t.content_image
                ? `${API_BASE}${t.content_image}`
                : t.avatar ?? null;
              return (
                <article className="ae-card" key={i}>
                  <p className="ae-quote"
                    dangerouslySetInnerHTML={{ __html: text }} />
                  <div className="ae-attr">
                    {avatar && (
                      <img src={avatar} alt={name} className="ae-av" />
                    )}
                    <div>
                      <span className="ae-name"
                        dangerouslySetInnerHTML={{ __html: name }} />
                      <span className="ae-role"
                        dangerouslySetInnerHTML={{ __html: role }} />
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      {/* ── CANDIDATE TESTIMONIALS ───────────────────────────── */}
      <section className="ae-section">
        <div className="sub-head">
          <span className="eye">Candidates</span>
          <h2 className="sub-h2">What candidates experience</h2>
        </div>
        <div className="ae-marquee">
          <div className="ae-track ae-track-rev">
            {candidates.map((ct, i) => {
              const text   = ct.content_text  ?? toText(ct.text);
              const name   = ct.content_title ?? ct.name  ?? "";
              const role   = ct.content_subtitle ?? ct.title ?? "";
              const avatar = ct.content_image
                ? `${API_BASE}${ct.content_image}`
                : ct.avatar ?? null;
              return (
                <article className="ae-card" key={i}>
                  <p className="ae-quote">{text}</p>
                  <div className="ae-attr">
                    {avatar && (
                      <img src={avatar} alt={name} className="ae-av" />
                    )}
                    <div>
                      <span className="ae-name">{name}</span>
                      <span className="ae-role">{role}</span>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      {/* ── CTA ──────────────────────────────────────────────── */}
      <section className="sub-cta">
        <span className="eye">Start now</span>
        <h2>See Ann at work in <em>your</em> hiring.</h2>
        <p className="sub">
          Talk to us and we'll run a live demo on one of your open roles.
        </p>
        <div className="ctas">
          <Link to="/contact-us" className="btn btn-primary btn-lg">
            Book a demo
          </Link>
          <Link to="/how-it-works" className="btn btn-secondary btn-lg">
            How Ann works
          </Link>
        </div>
      </section>

    </div>
  );
}
